import fs from 'node:fs'
import path from 'node:path'
import { applyAdminNamespaceToPath } from '@next-adapter/config/namespace/apply-admin-namespace-to-path.js'
import fsExtra from 'fs-extra'
import { writeNamespacedFile } from './write-namespaced-file.js'
export function copyNamespacedDirectory(srcDir: string, destDir: string, namespace: string): void {
  const entries = fs.readdirSync(srcDir, { withFileTypes: true })

  for (const entry of entries) {
    const namespacedName = applyAdminNamespaceToPath(entry.name, namespace)
    const srcPath = path.join(srcDir, entry.name)
    const destPath = path.join(destDir, namespacedName)

    if (entry.isDirectory()) {
      fsExtra.ensureDirSync(destPath)
      copyNamespacedDirectory(srcPath, destPath, namespace)
      continue
    }

    fsExtra.ensureDirSync(path.dirname(destPath))
    writeNamespacedFile(srcPath, destPath, namespace)
  }
}
